export default {
  forecastTitle: "college football & basketball recruiting forecasts"
};
